const mobileNavDrawer = () => {
  const $drawer = $('.js_navBtn');
  $drawer.on('click touch', () => {
    $('.m_header_nav').toggleClass('active');
  });
  // job/registerのスマホのナビのページ内リンク用・タブレット等の対応のため.activeのクラスで判定
  $(document).on('click touch', '.m_header_nav.active a', () => {
    $('.m_header_nav').toggleClass('active');
  });
}

export default mobileNavDrawer;
